// basket-api schema and docs: https://basket-api-shared.qa.noths.com/graphql

export const BASKET = `
query basketQuery($currency: Currency) {
  basket(currency: $currency) {
    discountedItemsTotal {
      cents
      currency
    }
    itemsTotal { currency, cents },
    membershipAddedStatus
  }
}
`;

export const BASKET_WITH_OPTIONS = `
query basketWithOptionsQuery {
  basket {
    discountedItemsTotal { currency, cents }
    items {
      id
      quantity
      options {
        optionId
        name
        type
        valueLabel
        value
        valueId
        prices {
          listPrice {
            currency
            cents
          }
          purchasePrice {
            currency
            cents
          }
          discountValue {
            currency
            cents
          }
          discountType
          discountPercent
        }
      }
    }
    itemsCount
    itemsTotal { currency, cents },
  }
}  
`;
